const AddressAbstract = require("components/abstract/Address");
const Input = require("components/forms/Input");

/////////////////////////////////
// Address field
/////////////////////////////////

class Address extends AddressAbstract {

	get description() {
		return "Format: [Vejnavn] [Husnummer] #[Lejlighed] [Postnummer] [By]";
	}

	getInputName(key) {
		if (typeof this.props.name !== "string") {
			return;
		}

		return `${this.props.name}[${key}]`;
	}

	render() {
		return (
			<Input inputRef={this._setInputRef} className={this.className} type="text" data-name={this.props.name}
						 defaultValue={this.value("name")} format={this.description} {...this.inputProps}>
				<input type="hidden" name={this.getInputName("street")} value={this.value("street")}/>
				<input type="hidden" name={this.getInputName("zip")} value={this.value("zip")}/>
				<input type="hidden" name={this.getInputName("city")} value={this.value("city")}/>
				<input type="hidden" name={this.getInputName("country")} value={this.value("country")}/>
				<input type="hidden" name={this.getInputName("latitude")} value={this.value("latitude")}/>
				<input type="hidden" name={this.getInputName("longitude")} value={this.value("longitude")}/>
			</Input>
		);
	}

}

module.exports = Address;



// WEBPACK FOOTER //
// ./resources/js/components/forms/Address.js